import { apiRequest } from "@/api";

const state = {
  users: {},
  infos: {
    user: {},
    prod_set: [],
  },
};

//add the date sent looks in Messages-dash
function date_form(date) {
  let d = (new Date(date.created_at) + "").split(" ");
  let tmp = [d[2], d[1], d[3], d[4]].join(" ");
  let res = tmp.split(":");
  date.created_at = `${res[0]}:${res[1]}`;
  d = (new Date(date.updated_at) + "").split(" ");
  tmp = [d[2], d[1], d[3], d[4]].join(" ");
  res = tmp.split(":");
  date.updated_at = `${res[0]}:${res[1]}`;
}

//////////////////////////////////////////////////////

const mutations = {
  SET_UPDATE_EMAIL: (state, { rootState, email, guid }) => {
    // set the email to the user class mutation
    const index = rootState.messages.filter_rest.findIndex(
      (x) => x.guid === guid
    );
    if (index >= 0) {
      //set email in messanger dash
      rootState.messages.filter_rest[index].contact = email;
      rootState.messages.filter_rest[index].email = email;
    }
    if (rootState.user.users[guid]) {
      //set in data users
      rootState.user.users[guid].email = email;
    }
    rootState.chat_user.email = email;

    console.log("SET_UPDATE_EMAIL", email, rootState.user.users[guid]);
  },
  SET_DATA: (state, object) => {
    state.users = {};
    for (var i = 0; object[i]; i++) {
      date_form(object[i]);
      state.users[object[i].guid] = object[i];
    }
  },
  SET_INFO: (state, data) => {
    if (data.products_liked)
      state.infos.prod_set = [...state.infos.prod_set, ...data.products_liked];
    if (data.products_disliked)
      state.infos.prod_set = [
        ...state.infos.prod_set,
        ...Object.keys(data.products_disliked),
      ];
    if (data.products_bookmarked) {
      if (typeof data.products_bookmarked === "object")
        state.infos.prod_set = [
          ...state.infos.prod_set,
          ...Object.keys(data.products_bookmarked),
        ];
      else
        state.infos.prod_set = [
          ...state.infos.prod_set,
          ...data.products_bookmarked,
        ];
    }
    if (data.products_seen)
      state.infos.prod_set = [...state.infos.prod_set, ...data.products_seen];
    state.infos.user = data;
  },
  SET_USER_OTHER_PRODUCTS: (state, prods) => {
    state.infos.prod_other = prods;
  },
};

const actions = {
  FETCH_USERS: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get("users/all")
        .then((response) => {
          const users = response.data.response;
          commit("SET_DATA", users);
          resolve(response);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  GET_USER_BY_GUID: ({ commit, rootState }, guid) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get("users/fetch?guid=" + guid)
        .then((r) => {
          resolve(r.data.data);
        });
    });
  },
  FETCH_USER: ({ commit, rootState, dispatch }, id) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get("users/fetch?id=" + id)
        .then((response) => {
          var infos = response.data.data;
          date_form(infos);
          commit("SET_INFO", infos);
          dispatch("SET_OTHER_PRODS");
          dispatch("SET_DISLIKED_PRODUCT");
          resolve(infos);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  EDIT_USER: ({}, params) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .post("users/updateData", params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
  SAVE_EMAIL: async ({ commit, rootState }, { email, guid }) => {
    return new Promise((resolve, reject) => {
      if (email && guid) {
        apiRequest()
          .post("users/email_update", { email, guid })
          .then(({ data }) => {
            ///call the commit to change the email in message and users data
            commit("SET_UPDATE_EMAIL", { rootState, email, guid });
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      } else reject("error in params");
    });
  },
};
export default {
  state,
  actions,
  mutations,
};
